import Cookies from "js-cookie";
import React, { useState, useCallback } from "react";
import { useAuth } from "@redwoodjs/auth";
import { getConfig } from "lib/web/config";
import { redirect } from "src/utils/location";

export const LoopUpOneRedirectContext = React.createContext();

export const LoopUpOneRedirectContextProvider = ({ children }) => {
  const config = getConfig();
  // Force redirect to always be true - users will automatically redirect to LoopUp One
  const [shouldRedirect, setShouldRedirect] = useState(true);
  const { currentUser } = useAuth();

  const conditionalRedirect = useCallback(
    (path: string) => {
      if (shouldRedirect) {
        redirect(
          `${config.loopUpOneUrl}/customers/${currentUser.customer.id}/${path}`
        );
      }

      return shouldRedirect;
    },
    [shouldRedirect, currentUser]
  );

  const setShouldRedirectWithCookie = useCallback(
    (shouldRedirect: boolean) => {
      Cookies.set("loopup_one_redirect", shouldRedirect ? "true" : "false", {
        expires: 365,
        domain: ".loopup.com",
      });
      setShouldRedirect(shouldRedirect);
    },
    [shouldRedirect]
  );

  return (
    <LoopUpOneRedirectContext.Provider
      value={{
        shouldRedirect,
        setShouldRedirect: setShouldRedirectWithCookie,
        conditionalRedirect,
      }}
    >
      {children}
    </LoopUpOneRedirectContext.Provider>
  );
};
